import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import Api from "../Api/Api.json";

const fetchData = async (id) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  const url = Api.PREGNANCY_DATA_API;
  const requestData = {
    task: "getLastNEmergencyRiskFactor",
    patient_id: id,
    last_n: 5
  };
  const response = await axios.post(url, requestData, headers);
  if (!response.data) {
    throw new Error("Network response was not ok");
  }
  if (response.data.length === 0 || response.data[0].risk_assessment === true) {
    return null;
  }
  // return response.data;
  const data = response.data.map((item) => {
    return JSON.parse(item.risk_assessment)[0];
  });
  return data;
};

export const useLastNEmergencyRiskFactor = (id) => {
  // Use React Query to fetch and cache data
  return useQuery({
    queryKey: ["getLastNEmergencyRiskFactor", id], // Unique key for this query
    queryFn: () => fetchData(id), // Function to fetch data
    staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
    cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes
  });
};